import { createSelector } from '@reduxjs/toolkit';
const getState = (state) => state.i18n;
const getTranslations = (state) => getState(state).translations?.paxGuide;
export const getTranslation = createSelector(getTranslations, translations => {
    return (key) => {
        if (translations && translations[key]) {
            return translations[key];
        }
        return key;
    };
});
//# sourceMappingURL=selectors.js.map